"use client";
import "../chunk-GOCCUU3Z.js";
import { truncateAddress, WalletType } from "@getpara/web-sdk";
const getExternalWalletDisplayName = ({ address, type }) => {
  const walletType = type;
  let walletTypeDisplay;
  switch (walletType) {
    case WalletType.EVM:
      walletTypeDisplay = "EVM";
      break;
    case WalletType.SOLANA:
      walletTypeDisplay = "Solana";
      break;
    case WalletType.COSMOS:
      walletTypeDisplay = "Cosmos";
      break;
  }
  return `${walletTypeDisplay} ${truncateAddress(address, walletType)}`;
};
export {
  getExternalWalletDisplayName
};
